import AppLayout from "./components/layouts/AppLayout";
import OverlayLoading from "src/components/common/OverlayLoading/OverlayLoading";
import RouteErrorBoundary from "./components/RouteErrorBoundary";
import type { AppRouteObject } from "./routes/types";
import { decoratedAppRouteChildren } from "./routes/routeRegistry";

export const routes: AppRouteObject[] = [
    {
        path: "/",
        element: <AppLayout />,
        hydrateFallbackElement: <OverlayLoading />,
        errorElement: <RouteErrorBoundary />,
        handle: {
            title: "Trial Management",
            help: null,
            access: null,
            // The shell title is not a navigable breadcrumb. Legacy pages
            // start at the first real route (for example, `Trials`).
            breadcrumb: null,
        },
        children: [
            ...decoratedAppRouteChildren,
        ],
    },
];
